import React from 'react';
import { Config, ConfigProvider } from '@workboard/project-management';

declare global {
  interface Window {
    imageBaseUrl: string;
    wbbaseUrl: string;
    app_url: string;
    wb_track?: (eventName: string, details: Record<string, unknown>) => void;
    csrfToken: string;
    refreshCsrfToken: (isAjaxRequest: boolean, isDebug: boolean) => void;
    uData: {
      user_id: string;
      org_id: string;
      time_zone: string;
      first_name: string;
      last_name: string;
      email: string;
      picture?: string;
      userIsReadOnly: boolean;
    };
  }
}

export const getGlobalConfig = (): Config => ({
  getCsrfToken: () => window.csrfToken,
  trackEvent: window.wb_track,
  timezone: window.uData.time_zone,
  enabledFeatures: Object.keys(window.wbConfig).filter(
    (flag) => (window.wbConfig as any)[flag] === true
  ),
  baseApiUrl: window.wbbaseUrl,
  baseAppUrl: `${window.location.origin}/wb`,
  baseImageUrl: window.imageBaseUrl,
});

export const GlobalConfigProvider = ({ children }: React.PropsWithChildren) => (
  <ConfigProvider config={getGlobalConfig()}>{children}</ConfigProvider>
);
